<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.mrchOrderNo" style="width: 250px;" size="mini" placeholder="商户订单号"
            clearable></el-input>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          <el-button type="warning" size="mini" style="" @click="handleExport">导出</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import { getYbtPayOrderResponseList } from "../../api/api";
import axios from 'axios';
import qs from "qs";
import config from "../../api/env.js";

export default {
  name: "YbtPayOrderResponse",
  data() {
    return {
      tableLoading: false,
      loadings: null,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      formDatas: {
        mrchOrderNo: '',
        currentPage: 1,
        pageSize: 10
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "merchantNo",
          key: "merchantNo",
          title: "商户号",
          width: 150,
          align: "center",
        },
        {
          field: "mrchOrderNo",
          key: "mrchOrderNo",
          title: "商户订单号",
          width: 280,
          align: "center",
        },
        {
          field: "code",
          key: "code",
          title: "响应状态码",
          width: 120,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const isSuccess = row.code === '0000';
            return h('el-tag', { props: { type: isSuccess ? 'success' : 'danger', size: 'mini' } }, row.code || '-');
          },
        },
        {
          field: "msg",
          key: "msg",
          title: "响应描述",
          align: "center",
          width: 200,
        },
        {
          field: "payUrl",
          key: "payUrl",
          title: "支付网关URL",
          align: "center",
          width: 300,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (!row.payUrl) return '-';
            return h('el-tooltip', {
              props: { content: row.payUrl, placement: 'top', 'open-delay': 500 }
            }, [
              h('span', { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', maxWidth: '280px' } }, row.payUrl)
            ]);
          },
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          width: 170,
          align: "center",
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getYbtPayOrderResponseList(this.formDatas).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    handleExport() {
      const params = {
        mrchOrderNo: this.formDatas.mrchOrderNo
      };
      const s = qs.stringify(params);
      this.openLoading();
      axios({
        method: 'post',
        url: config.baseURL + '/ybt-pay-order-response/exportYbtPayOrderResponse',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then((res) => {
        if (res.data) {
          this.loadings.close();
          const a = document.createElement('a');
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          const objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '支付接口响应结果.xlsx');
          a.click();
          this.$message.success('导出成功');
        }
      }).catch(() => {
        this.loadings.close();
        this.$message.error('导出失败');
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: "导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
  },
};
</script>

<style scoped></style>
